import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Form, Input, Empty, Spin, Divider } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import TagSelectF from '@/i2antdV5/TagSelectF'
import { fetchMaternityCenterUserList } from '@/redux/use/maternityCenterUserSlice'

class DispatcherTechnicianForm extends React.Component {
  static propTypes = {
    storeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onSelectionChange: PropTypes.func,
    form: PropTypes.object,
    technicianList: PropTypes.array,
    nurseList: PropTypes.array,
    technicianValue: PropTypes.array,
    nurseValue: PropTypes.array,
    fetching: PropTypes.bool,
    dispatch: PropTypes.func
  }

  state = {
    technicianKeyword: '',
    nurseKeyword: ''
  }

  componentDidMount() {
    this.fetchStaffList()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.storeId !== this.props.storeId) {
      this.fetchStaffList()
    }
  }

  fetchStaffList = () => {
    const { storeId, dispatch } = this.props
    if (storeId) {
      dispatch(fetchMaternityCenterUserList({
        serviceType: 'TECHNICIAN',
        dataType: 'option',
        query: { storeId }
      }))
      dispatch(fetchMaternityCenterUserList({
        serviceType: 'NURSE',
        dataType: 'option',
        query: { storeId }
      }))
    }
  }

  /** 将 technicians/nurses 转为 ID 数组，兼容 [id] 或 [{ id }] 格式 */
  normalizeToIds = (arr) => {
    if (!Array.isArray(arr) || arr.length === 0) return []
    const first = arr[0]
    return typeof first === 'object' && first != null && 'id' in first
      ? arr.map((x) => x.id)
      : arr
  }

  filterByKeyword = (list, keyword) => {
    if (!keyword) return list
    const lower = keyword.toLowerCase()
    return list.filter((item) => {
      const searchStr = `${item.value}${item.id}`.toLowerCase()
      return searchStr.includes(lower)
    })
  }

  render() {
    const { technicianKeyword, nurseKeyword } = this.state
    const { technicianList, nurseList, fetching, form, technicianValue, nurseValue } = this.props
    const filteredTechnicianList = this.filterByKeyword(technicianList, technicianKeyword)
    const filteredNurseList = this.filterByKeyword(nurseList, nurseKeyword)
    return (
      <div className="dispatch-staff-form">
        <Form
          ref={form}
          initialValues={{
            technicianId: this.normalizeToIds(technicianValue),
            nurseId: this.normalizeToIds(nurseValue)
          }}
        >
          <Spin spinning={fetching}>
            <div className="staff-section">
              <div className="section-label">专属产康师</div>
              <div className="search-wrap">
                <Input
                  placeholder="搜索产康师姓名或工号"
                  prefix={<UserOutlined />}
                  value={technicianKeyword}
                  onChange={(e) => this.setState({ technicianKeyword: e.target.value })}
                  allowClear
                />
              </div>
              {filteredTechnicianList.length === 0 ? (
                <Empty description={fetching ? '加载中...' : '暂无可用产康师'} />
              ) : (
                <Form.Item name="technicianId" noStyle>
                  <TagSelectF options={filteredTechnicianList} />
                </Form.Item>
              )}
            </div>

            <Divider />

            <div className="staff-section">
              <div className="section-label">专属护理师</div>
              <div className="search-wrap">
                <Input
                  placeholder="搜索护理师姓名或工号"
                  prefix={<UserOutlined />}
                  value={nurseKeyword}
                  onChange={(e) => this.setState({ nurseKeyword: e.target.value })}
                  allowClear
                />
              </div>
              {filteredNurseList.length === 0 ? (
                <Empty description={fetching ? '加载中...' : '暂无可用护理师'} />
              ) : (
                <Form.Item name="nurseId" noStyle>
                  <TagSelectF options={filteredNurseList} />
                </Form.Item>
              )}
            </div>
          </Spin>
        </Form>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const {
    TECHNICIAN: { data: technicianList, fetching: technicianFetching },
    NURSE: { data: nurseList, fetching: nurseFetching }
  } = state.use.maternityCenterUser
  const fetching = technicianFetching || nurseFetching
  return { technicianList, nurseList, fetching }
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(DispatcherTechnicianForm)
